import BaseService from './BaseService.js'

export default {
  get(id) {
    return BaseService.get(`Document/${id}`)
  },
  post(document) {
    const formData = new FormData()
    formData.append('changeID', document.changeID)
    formData.append('description', document.description)
    formData.append('file', document.file)

    return BaseService.postFormData(`Document`, formData)
  },
  delete(id) {
    return BaseService.delete(`Document/${id}`)
  },
  validate(changeId) {
    return BaseService.post(`Document/Validate`, changeId)
  }
}
